import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgProportionalFeederMetering = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 300,
	height: 50,
	viewBox: "0 0 300.0 50.0",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M 80.0 0.0 A 40.0 40.0 0.0 1 1 0.0 0.0 L 300.0 0.0 A 40.0 40.0 0.0 1 1 220.0 0.0 Z M 150.0 1.0 L 180.0 50.0 L 120.0 50.0 Z",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	})
});
export default SvgProportionalFeederMetering;
